(function(){
  var root = document.querySelector('.gifts-cs-faq')
  if(!root) return
  root.querySelectorAll('.gifts-cs-faq-question').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.parentElement
      root.querySelectorAll('.gifts-cs-faq-item').forEach(function(i){
        if(i !== item){ i.classList.remove('active') }
      })
      item.classList.toggle('active')
    })
  })
})()